import ListaKm from '../componentes/ListaKm.vue'


const routes = [
  
     ...route('/lista-km', ListaKm, {
       Auth: true,
       //req_admin: true
    }),
]

function route(path, component = Default, meta = {}) {
	return [{
		path,
		component,
		meta
	}]
}

export default routes